import * as React from 'react';

import { assert } from '@gitbook/util-ts';

import { OverlayContext } from './OverlayContext';

/**
 * Hook to start a overlay action and handle the pending state of the overlay.
 */
export function useOverlayAction() {
    const context = React.useContext(OverlayContext);
    assert(context !== null, 'useOverlayAction must be used within a OverlayRoot.');
    const { setIsPending, closeAndWaitForAnimation } = context;
    const startDialogAction = React.useCallback(
        (action: ({ close }: { close: () => Promise<void> }) => Promise<void>) => {
            setIsPending(true);
            return action({ close: closeAndWaitForAnimation }).finally(() => {
                setIsPending(false);
            });
        },
        [setIsPending, closeAndWaitForAnimation]
    );
    return [context.isPending, startDialogAction] as const;
}
